import React  from 'react';
import styled, { keyframes } from 'styled-components';
import { bounce } from 'react-animations';
import NextButton from '../../components/nextButton';
import anifin from './images/ani-finik.gif';
import rocket from './images/rocket1.png';
import './style.css';
 
const Hello = styled.div`
animation: 2s ${keyframes`${bounce}`} ;
  align-self: flex-start;
  font-family: 'Marck Script', sans-serif;
  color: #03e0b3;
  font-size: 60px;
  line-height: 1.3em;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: none;
  @media screen and (max-width: 991px) {
    display: block;
    color: #00fcff;
    font-size: 48px;
  }
  @media screen and (max-width: 767px) {
      font-size: 38px;
  }

  @media screen and (max-width: 479px) {
    padding-left: 25vw;
    -ms-grid-row-align: center;
    align-self: center;
  }

`;


const Page00 = ({ onNextLevel, messNext } ) => {
  return (
    <div className="section-info section-first">
      <div className="content-first w-container">
        <div className="head-content">
          {/* <div className="head-first">Привет!</div> */}
          <Hello >Привет!</Hello>
          <div className="text-block-first">Меня зовут Финик.<br/>Я живу в стране <span className="span-first">Финансов.</span><br/></div> 
          <NextButton classes="button-q w-button" onNextLevel={onNextLevel} messNext="вперёд" />
          <img src={anifin} loading="lazy" alt="" className="finik"/>
          {/* finik-first.png */}
          </div>
      </div>
      <img  className="rocket" src={rocket} loading="lazy" alt="" />
    </div>

      );
}

export default Page00;
